import type { ReactNode } from 'react';
import React from 'react';

import DialogContent from '@mui/material/DialogContent';

import StdDialog from 'components/Dialogs/StdDialog';

export const DIALOG_TYPE_EMPTY_DIALOG = 'DIALOG_TYPE_EMPTY_DIALOG';

export type EmptyDialogProps = {
  content: ReactNode;
  dialogId: string;
  type?: string;
} & Record<string, unknown>;

const EmptyDialog = ({ content, ...otherProps }: EmptyDialogProps): React.JSX.Element => {
  return (
    <StdDialog sharedcomponentid={DIALOG_TYPE_EMPTY_DIALOG} {...otherProps}>
      <DialogContent>{content}</DialogContent>
    </StdDialog>
  );
};

export default EmptyDialog;
